import moment from 'moment-timezone';

export default {
    install(Vue) {
        const convertDate = function (dateString, toUI = true) {
            if (dateString === null || dateString === '') return '';

            if (toUI) {
                const date = moment.utc(dateString, 'YYYY-MM-DDTHH:mm:ss');
                const localDate = date.tz(moment.tz.guess());
                const formattedDate = localDate.format('YYYY-MM-DD HH:mm');
                return formattedDate;
            } else {
                const date = new Date(dateString)
                const utcDate = moment.tz(date, moment.tz.guess()).utc();
                const formattedDate = utcDate.format('YYYY-MM-DDTHH:mm:ss');
                return formattedDate;
            }
        };
        Vue.prototype.$utcToCurrentDate = function (date) {
            return convertDate(date, true);
        };
        Vue.prototype.$dateToUtc = function (date) {
            return convertDate(date, false);
        };

    }
}